// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__RqluF","sidenav":"Content_sidenav__hBJux","content":"Content_content__2KyvG"};